// Lines dictionary Keyword
export const eyebrowKeyLineSpeicalOffers = 'cnhi-lineSpecialOffersEyebrow';
export const titleKeyLineSpeicalOffers = 'cnhi-lineSpecialOffersTitle';
export const descriptionKeyLineSpeicalOffers = 'cnhi-lineSpecialOffersDescription';

export const eyebrowKeyLineBrochure = 'cnhi-lineBrochureEyebrow';
export const titleKeyLineBrochure = 'cnhi-lineBrochureTitle';
export const descriptionKeyLineBrochure = 'cnhi-lineBrochureDescription';

// Series dictionary keyword

export const titleKeySeriesFeature = 'cnhi-seriesFeaturesTitle';

export const titleKeyModelListing = 'cnhi-seriesModelsTitle';
export const eyebrowKeyModelListing = 'cnhi-seriesModelsEyebrow';
export const descriptionKeyModelListing = 'cnhi-seriesModelsDescription';

export const eyebrowKeySeriesSpeicalOffers = 'cnhi-seriesSpecialOffersEyebrow';
export const titleKeySeriesSpeicalOffers = 'cnhi-seriesSpecialOffersTitle';
export const descriptionKeySeriesSpeicalOffers = 'cnhi-seriesSpecialOffersDescription';

export const titleKeySeriesCompatibleAttachments = 'cnhi-seriesCompatibleAttachmentsTitle';
export const descriptionKeySeriesCompatibleAttachments =
  'cnhi-seriesCompatibleAttachmentsDescription';

export const eyebrowKeySeriesBrochure = 'cnhi-seriesBrochureEyebrow';
export const titleKeySeriesBrochure = 'cnhi-seriesBrochureTitle';
export const descriptionKeySeriesBrochure = 'cnhi-seriesBrochureDescription';

export const eyebrowKeySeriesSpecifications = 'cnhi-seriesSpecificationsEyebrow';
export const titleKeySeriesSpecifications = 'cnhi-seriesSpecificationsTitle';
export const notesKeySeriesSpecifications = 'cnhi-seriesSpecificationsNotes';

export const eyebrowKeySeriesMediaGallery = 'cnhi-seriesMediaGalleryEyebrow';
export const titleKeySeriesMediaGallery = 'cnhi-seriesMediaGalleryTitle';
export const descriptionKeySeriesMediaGallery = 'cnhi-seriesMediaGalleryDescription';

export const titleKeySeriesSolutions = 'cnhi-seriesSolutionsTitle';

export const eyebrowKeySeriesTestimonials = 'cnhi-seriesTestimonialsEyebrow';
export const titleKeySeriesTestimonials = 'cnhi-seriesTestimonialsTitle';
export const descriptionKeySeriesTestimonials = 'cnhi-seriesTestimonialsDescription';

// Models dictionary keyword

export const titleKeyModelFeatures = 'cnhi-modelFeaturesTitle';

export const titleKeyModelCompatibleAttachments = 'cnhi-modelCompatibleAttachmentsTitle';
export const descriptionKeyModelCompatibleAttachments =
  'cnhi-modelCompatibleAttachmentsDescription';

export const eyebrowKeyModelSpecifications = 'cnhi-modelSpecificationsEyebrow';
export const titleKeyModelSpecifications = 'cnhi-modelSpecificationsTitle';

export const eyebrowKeyModelMediaGallery = 'cnhi-modelMediaGalleryEyebrow';
export const titleKeyModelMediaGallery = 'cnhi-modelMediaGalleryTitle';
export const descriptionKeyModelMediaGallery = 'cnhi-modelMediaGalleryDescription';

export const titleKeyModelSolutions = 'cnhi-modelSolutionsTitle';

export const eyebrowKeyModelBrochure = 'cnhi-modelBrochureEyebrow';
export const titleKeyModelBrochure = 'cnhi-modelBrochureTitle';
export const descriptionKeyModelBrochure = 'cnhi-modelBrochureDescription';

export const titleKeyLatestDownloadBrochures = 'cnhi-latestBrochureTitle';
export const eyebrowKeyLatestDownloadBrochures = 'cnhi-latestBrochureEyebrow';
export const descriptionKeyLatestDownloadBrochures = 'cnhi-latestBrochureDescription';
